import { FormControlBase } from './form-control-base';

export class TextboxControl extends FormControlBase<string> {
    public controlType = 'textbox';
    public type: string = '';
    public placeHolder: string = '';
    public preventKeys: any = '';
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/dynamic-form/textbox-control.ts